import { render, staticRenderFns } from "./onefloor.vue?vue&type=template&id=6a4796a3&scoped=true&"
import script from "./onefloor.vue?vue&type=script&lang=js&"
export * from "./onefloor.vue?vue&type=script&lang=js&"
import style0 from "./onefloor.vue?vue&type=style&index=0&id=6a4796a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4796a3",
  null
  
)

export default component.exports